import { useEffect } from 'react';
import StyledUnityLoader from '../../../../../../styled-components/StyledUnityLoader';
import useUser from '../../../helpers/useUser';
import useProvideHls from '../helpers/useProvideHls';
import useUnityUrl from '../helpers/useUnityUrl';
import { GlobalEmbedStyles, Unity, UnityWrapper } from '../Unity.styled';
import getConfig from '../../../../../../lib/config';
import usePublicToken from '@core/helpers/usePublicToken';
import { isPublicSimPlayerPage } from '@core/components/Simulation/helpers/isPublicSimPlayerPage';
import { useLocation } from 'react-router-dom';

const REACT_APP_REMOTE_URI = getConfig('REACT_APP_REMOTE_URI');
const REACT_APP_ENV = process.env.REACT_APP_ENV;

export const UnityWebPlayer = ({
  preview,
  editor,
  simulationData,
  context,
  publicFlag,
}) => {
  useProvideHls();
  const location = useLocation();

  const isPublic = isPublicSimPlayerPage(location);
  const {
    data: publicData,
    error: publicError,
    called,
  } = usePublicToken({ skip: !isPublic });

  const loggedUser = useUser();

  const user = isPublic ? publicData?.createPublicToken?.Member : loggedUser;

  const url = useUnityUrl();
  const { isLoaded, loadingProgression } = context;

  useEffect(() => {
    document.unityWebAppPreviewMode = JSON.stringify(Boolean(preview));

    document.unityWebAppEditorMode = JSON.stringify(Boolean(editor));

    document.unityWebAppSimData = JSON.stringify(simulationData);

    document.unityWebAppUserData = JSON.stringify(user);

    document.unityWebAppPublicFlag = publicFlag ? 'true' : '';

    document.remoteURI = REACT_APP_REMOTE_URI + 'graphql';

    document.unityWebAppEnv = REACT_APP_ENV;
  }, [preview, editor, simulationData, user, publicFlag]);

  if (!context) {
    return null;
  }
  if (publicError) {
    console.error('Error loading public user', publicError);
  }
  return (
    <>
      {!isLoaded && (
        <StyledUnityLoader progress={Math.round(loadingProgression * 100)} />
      )}
      <UnityWrapper>
        <GlobalEmbedStyles />
        {(!isPublic || (called && publicData)) && (
          <Unity key={url} unityProvider={context.unityProvider} />
        )}
      </UnityWrapper>
    </>
  );
};

export default UnityWebPlayer;
